export default __webpack_public_path__ + "static/media/Forward.e6c859c3.svg";